/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';

const variables = [
  {
    key: '${object}',
    name: 'Object',
  },
  {
    key: '${block}',
    name: 'Block',
  },
  {
    key: '${entrance}',
    name: 'Padez',
  },
  {
    key: '${stage}',
    name: 'Qavat',
  },
  {
    key: '${home}',
    name: 'Uy raqam',
  },
  {
    key: '${number}',
    name: 'Tartib raqam',
  },
];

function Template({ defaultText, open, onChange }) {
  const textDiv = useRef(null);
  const observerRef = useRef(null);
  const [initialText, setInitialText] = useState(null);

  useEffect(() => {
    if (defaultText && open) {
      let innerText = defaultText?.replaceAll('\n', '<br />');

      for (let x = 0; x < variables?.length; x++) {
        const { key } = variables[x];
        const span = `<span
            contenteditable='false'
            class='rounded-md px-1 bg-base-color-light-f-15 text-sm whitespace-nowrap text-base-color-light'
          >
            ${key}
            <i class='bi bi-x cursor-pointer ml-1 remove-key-element' onclick="this.parentNode.remove()"></i>
          </span>`;

        if (innerText?.includes(key)) {
          innerText = innerText?.replaceAll(key, span);
        }
      }

      setInitialText(innerText);
    } else {
      setInitialText('');
    }
  }, [defaultText, textDiv?.current, open]);

  function insertTextAtCaret(text) {
    const span = document.createElement('span');
    const i = document.createElement('i');
    span.setAttribute(
      'class',
      'rounded-md px-1 bg-base-color-light-f-15 text-sm text-base-color-light whitespace-nowrap',
    );
    span.setAttribute('contenteditable', 'false');

    i.onclick = () => {
      span?.remove();
    };
    i.setAttribute('class', 'bi bi-x cursor-pointer ml-1 remove-key-element');
    span.innerText = text;
    span.appendChild(i);
    var sel, range;
    if (window.getSelection) {
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        range.insertNode(span);
        sel.collapseToEnd();
      }
    }
  }

  useEffect(() => {
    if (!textDiv.current) return;

    observerRef.current = new MutationObserver(() => {
      const newContent = textDiv.current.innerText;
      onChange(newContent);
    });

    observerRef.current.observe(textDiv.current, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });

    return () => {
      observerRef.current?.disconnect();
    };
  }, []);

  return (
    <div>
      <div className='text-md text-black font-normal'>
        <div
          ref={textDiv}
          key={defaultText}
          className={
            'settings-sms-template w-full text-sm py-4 px-4 border-gray-900 focus-within:border-blue-600 border-2 rounded-md outline-none editing'
          }
          contentEditable
          dangerouslySetInnerHTML={{ __html: initialText }}
          onInput={(e) => onChange(e?.target?.innerText)}
        />
      </div>

      <div className='mt-4 flex justify-between'>
        <div className='flex gap-2 flex-wrap'>
          {variables?.map((temp) => (
            <Button
              key={temp?.key}
              color='primary'
              variant='contained'
              className='!py-1'
              size='small'
              onClick={(e) => {
                textDiv.current.focus();
                insertTextAtCaret(temp.key);
                e.preventDefault();
              }}
            >
              {temp?.name}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(Template);
